import { animate, style, transition, trigger } from "@angular/animations";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from "@angular/core";
import { Subscription } from "rxjs";
import { KwikUIToasterService } from "./toaster.service";

@Component({
  selector: "kwikui-toaster",
  templateUrl: "./toaster.component.html",
  styleUrls: ["./toaster.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("panelInOut", [
      transition(":enter", [
        style({ opacity: 0, transform: "{{enterTransform}}" }),
        animate(150)
      ]),
      transition(":leave", [
        animate(100, style({ opacity: 0, transform: "{{exitTransform}}" }))
      ])
    ])
  ]
})
export class KwikUIToasterComponent implements OnInit, OnDestroy {
  isToasterVisible = false;

  private toasterSubscription: Subscription;

  constructor(
    public toasterService: KwikUIToasterService,
    private cdr: ChangeDetectorRef
  ) {
    this.toasterSubscription = this.toasterService.showToaster.subscribe(
      (isVisible) => {
        this.isToasterVisible = isVisible;
        this.cdr.markForCheck();
      }
    );
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    // Clean up subscription
    this.toasterSubscription.unsubscribe();
  }

  /**
   * Returns animation parameters based on toaster position
   */
  getAnimationParams(): { enterTransform: string; exitTransform: string } {
    const position = this.toasterService.position || "";

    if (position.startsWith("top")) {
      return {
        enterTransform: "translateY(-20px)",
        exitTransform: "translateY(-20px)"
      };
    }
    if (position.startsWith("bottom")) {
      return {
        enterTransform: "translateY(20px)",
        exitTransform: "translateY(20px)"
      };
    }
    if (position.includes("left")) {
      return {
        enterTransform: "translateX(-20px)",
        exitTransform: "translateX(-20px)"
      };
    }
    if (position.includes("right")) {
      return {
        enterTransform: "translateX(20px)",
        exitTransform: "translateX(20px)"
      };
    }
    // Default animation for center positions
    return { enterTransform: "scale(0.9)", exitTransform: "scale(0.9)" };
  }
}
